const EpousesDetailsPrestataireData = [
    {
        id: 1,
        prenom: 'Sophie Ndiaye',
        age: '28 ans'
    },
];

export default EpousesDetailsPrestataireData;
